import Base from './Base';

export default class CustomField extends Base {
    get typeLabel() {
        return this.types[this.type];
    }
}
